import React from 'react';
import { Card, Typography, Box } from '@mui/material';

const IconCard = ({ title, description, icon, color }) => {
  // Split the title at the first occurrence of "&"
  const [firstPart, secondPart] = title.split('&').map((part) => part.trim());

  return (
    <Card
      sx={{
        display: 'flex',
        boxShadow: 0,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        height: '100%', // Ensures the card fills the grid item's height
      }}
    >
      {/* Left Side: Title and Description */}
      <Box
        sx={{
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start', // Align items to the top
          padding: 3,
          overflow: 'hidden',
        }}
      >
        <Typography variant="h6" fontWeight="bold" mb={1}>
          {firstPart} &<br />
          {secondPart}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {description}
        </Typography>
      </Box>

      {/* Right Side: Icon */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'stretch', // Stretch to fill vertical space
          justifyContent: 'center',
          backgroundColor: 'background.default',
          padding: 2,
        }}
      >
        {icon && (
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: color,
            }}
          >
            {React.cloneElement(icon, { style: { height: '80%', width: 'auto' } })}
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default IconCard;
